import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from '../../contexts/authentication/AuthProvider';
import { useContext, useState } from 'react';
import { clearCookies } from 'src/utils/cookiesHelper';
import { loginRedirect } from 'src/utils/loginRedirect';

const AuthGuard = ({ children }: React.PropsWithChildren) => {
  const [requestedLocation, setRequestedLocation] = useState<string | null>();
  const auth = useContext(AuthContext);
  const location = useLocation();

  if (!auth.isAuthenticated) {
    clearCookies();
    loginRedirect();
  }

  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default AuthGuard;
